<div
  [formGroup]="formGroup!"
  [class]="config?.cssClass ? 'mb-4 ' + config!.cssClass: 'form-group'"
>
  <label
    for="{{ config?.name }}"
    class="mb-1 fw-bold"
  >
    {{ config?.label }}
  </label>

  <ul
    class="list-group"
    [formArrayName]="config?.name ?? null"
  >
    @for (control of controls; track control; let i = $index) {
      @if (config?.options?.[i]; as option) {
        <li class="list-group-item-check">
          <div class="form-check">
            <input
              name="{{ config!.name + i }}"
              id="{{ config!.name + i }}"
              class="form-check-input"
              type="checkbox"
              [formControlName]="i"
              [value]="option!.value"
              [checked]="option!.checked"
              (change)="option!.checked = $any($event.target).checked"
            />
            <label
              for="{{ config!.name + i }}"
              class="form-check-label"
            >
              {{ option!.text }}
            </label>
          </div>
        </li>
      }
    }
  </ul>
  @if (!validation && config?.clicked) {
    <div class="invalid-feedback">Please select one of the options above</div>
  }
</div>
